module.exports = __webpack_public_path__ + "btn-sing-chorus.d3ca95f4.png";